export default {
  ENV: 'prod',
  TRACKING_SERVICE_BASE_URL_V1: 'https://tracking-api.mozio.com/v1',
  FIRELINKS_BASE_URL: 'https://links.mozio.com',
  USER_NAVIGATION_SHOW: true,
  FOOTER_SHOW: true,
  TRAVELER_OPTIONS_SHOW: true,
  POPULAR_RIDE_SHOW: true,
  SHOW_SIGNIN_BUTTON: true,
  SHOW_SRP_MAP: true,
  REGISTER_TA_SHOW: true,
  GOOGLE_ANALYTICS_KEY_PARTNER: 'UA-86969688-1',
  SHOW_SOCIAL_LOGIN: true,
  SHOW_PARKCLOUD_BANNER: true,
  SHOW_MOZIO_GROUP_HOMEPAGE: true,
  SHOW_PARKING_SEARCH: true,
  ESIM_ENABLE: true,
  VEHICLE_CLASS_TOP_RESULTS: true,
  INTERCOM_ENABLED: true,
  MOZIO_PUBLIC_INTERCOM_APP_ID: 'mdjjo7g6',
  // MINIMAL_SUPPLIER_SCORE: 8,
};
